import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ThumbUp } from '@mui/icons-material';
import './DrawingCard.css';

export default function DrawingCard({ drawing }) {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const up = drawing.votes?.up || 0;
    const down = drawing.votes?.down || 0;
    const total = up + down;
    const avg = total > 0 ? Math.round((up / total) * 100) : null;

    return (
        <div className="DrawingCard" onClick={() => navigate(`/gallery/${drawing.id}`)}>
            <div className="DrawingCard-thumb">
                {drawing.thumbnail ? (
                    <img src={drawing.thumbnail} alt="" draggable={false} />
                ) : (
                    <span className="DrawingCard-no-thumb">{t('roomCard.noPreview', 'No preview')}</span>
                )}
                {avg !== null && (
                    <span className={`DrawingCard-score${avg > 0 ? ' positive' : avg < 0 ? ' negative' : ''}`}>
                        <ThumbUp style={{ fontSize: 12 }} /> {`${avg}%`}
                    </span>
                )}
            </div>
        </div>
    );
}
